// extracted by mini-css-extract-plugin
module.exports = {"container":"_a473c384"};